/**
 * Plugin Registry
 * The Core hosts plugins that describe:
 *   { id, name, version, icon, description, host, projector, settingsTab, register() }
 *
 * Registration is static at bootstrap. Adding a new plugin later
 * is a one-line registerPlugin() call - no changes to the Core.
 */

const plugins = new Map();

export function registerPlugin(plugin) {
  if (!plugin?.id) {
    throw new Error("registerPlugin: missing id");
  }
  if (plugins.has(plugin.id)) {
    console.warn(`[registry] plugin "${plugin.id}" already registered`);
    return;
  }
  plugins.set(plugin.id, plugin);
  if (typeof plugin.register === "function") {
    try {
      plugin.register();
    } catch (e) {
      console.error(`[registry] plugin "${plugin.id}" register() failed`, e);
    }
  }
}

export function getPlugin(id) {
  return plugins.get(id) || null;
}

export function listPlugins() {
  return Array.from(plugins.values());
}
